import { render, staticRenderFns } from "./ClientProjectsEditDetails.vue?vue&type=template&id=566c8a16&scoped=true&"
import script from "./ClientProjectsEditDetails.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClientProjectsEditDetails.vue?vue&type=style&index=0&id=566c8a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c8a16",
  null
  
)

export default component.exports